export const skillsCards = [
  {
    name: "Html",
    img: "https://i.imgur.com/Bjbx1mq.png",
  },
  {
    name: "Css",
    img: "https://i.imgur.com/5Z3SIbz.png",
  },

  {
    name: "JavaScript",
    img: "https://i.imgur.com/d9RJvr9.png",
  },
  {
    name: "Typescript",
    img: "https://i.imgur.com/CBSIUUU.png",
  },
  {
    name: "React",
    img: "https://i.imgur.com/JLkSQfx.png",
  },
  {
    name: "Node",
    img: "https://i.imgur.com/1dWWm12.png",
  },
  {
    name: "Express",
    img: "https://i.imgur.com/d2JpzDp.png",
  },
  {
    name: "Postgre",
    img: "https://i.imgur.com/Kp2l2s1.png",
  },
  {
    name: "Git",
    img: "https://i.imgur.com/pAMyRnL.png",
  },

  {
    name: "Docker",
    img: "https://i.imgur.com/vcMT65W.png",
  },
  {
    name: "Insomnia",
    img: "https://i.imgur.com/K0vZ85q.png",
  },
  {
    name: "Beekeeper",
    img: "https://i.imgur.com/5SSwhcE.png",
  },

  {
    name: "Ubuntu",
    img: "https://i.imgur.com/AxGDyQP.png",
  },
  {
    name: "Windows",
    img: "https://i.imgur.com/tSqPy8k.png",
  },
  {
    name: "VScode",
    img: "https://i.imgur.com/uGfOLXp.png",
  },
  {
    name: "Trello",
    img: "https://i.imgur.com/VuVT3V5.png",
  },
  {
    name: "Notion",
    img: "https://i.imgur.com/uDAFM7Q.png",
  },
  {
    name: "Figma",
    img: "https://i.imgur.com/1fPj6tl.png",
  },
  {
    name: "Miro",
    img: "https://i.imgur.com/nG2Z0Ce.png",
  },
  {
    name: "Photoshop",
    img: "https://i.imgur.com/xCH2ry2.png",
  },
];
